import React from 'react';
import BiltyReport from '../BiltyReport';

export default function ReportDeletedBilty({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("delete-bilty-report")){
    return;}
  return (
    <div className="page-bilty">
    <BiltyReport sessionObject={sessionObject} />
    </div>
  );
}
